// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "http://api.pointnest.trangotechdevs.com:3061";
const BASE_URL = "https://api.bizooka.co";
// const BASE_URL = "https://api-bizooka.trangotechdevs.com";
// APIs design from Shaheer
const API_URL = BASE_URL + "/api/admin/";

const INITIAL_TOKEN = "d9cbb0a2-87aa-4f20-93d6-5e0bcbe7a59a";

export { API_URL, BASE_URL, INITIAL_TOKEN };
